/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MTP Service Mobile API
 * API REST pour l'espace client mobile - Migration Symfony 7.3
 * OpenAPI spec version: 2.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ArbitrageDetailItem,
  DocumentResponse,
  GetApiArbitrageAvenantParams,
  GetApiArbitrageDetail401,
  GetApiArbitrageDetail403,
  GetApiArbitrageDetail409,
  GetApiArbitrageDetail410,
  GetApiArbitrageDetail502,
  GetApiArbitrages200Item,
  GetApiArbitrages401,
  GetApiArbitrages403,
  GetApiArbitrages502,
  GetApiArbitragesParams,
  PostApiArbitrageAccept200,
  PostApiArbitrageAccept401,
  PostApiArbitrageAccept403,
  PostApiArbitrageAccept409,
  PostApiArbitrageAccept410,
  PostApiArbitrageAccept422,
  PostApiArbitrageAccept502,
  PostApiArbitrageAccept504,
  PostApiArbitrageAcceptBody,
  PostApiArbitrageRefuse401,
  PostApiArbitrageRefuse403,
  PostApiArbitrageRefuse422,
  PostApiArbitrageRefuse502,
  PostApiArbitrageRefuseBody,
} from '../placementApi.schemas.ts';

import postApiArbitrageAcceptMutator from '.././mutator/placement-instance.ts';
import getApiArbitrageAvenantMutator from '.././mutator/placement-instance.ts';
import getApiArbitrageDetailMutator from '.././mutator/placement-instance.ts';
import postApiArbitrageRefuseMutator from '.././mutator/placement-instance.ts';
import getApiArbitragesMutator from '.././mutator/placement-instance.ts';

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Vérifie l'éligibilité de l'arbitrage, contrôle l'identité Universign du client  et créer une liasse de signature de l'arbitrage
 * @summary Acceptation d'un arbitrage
 */
export const postApiArbitrageAccept = (
  arbitrageId: string,
  postApiArbitrageAcceptBody: PostApiArbitrageAcceptBody,
  signal?: AbortSignal
) => {
  return postApiArbitrageAcceptMutator<PostApiArbitrageAccept200>({
    url: `/api/arbitrages/${arbitrageId}/accept`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postApiArbitrageAcceptBody,
    signal,
  });
};

export const getPostApiArbitrageAcceptMutationKey = () => ['postApiArbitrageAccept'] as const;

export const getPostApiArbitrageAcceptMutationOptions = <
  TError =
    | PostApiArbitrageAccept401
    | PostApiArbitrageAccept403
    | PostApiArbitrageAccept409
    | PostApiArbitrageAccept410
    | PostApiArbitrageAccept422
    | PostApiArbitrageAccept502
    | PostApiArbitrageAccept504,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiArbitrageAccept>>,
    TError,
    PostApiArbitrageAcceptMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiArbitrageAccept>>,
  TError,
  PostApiArbitrageAcceptMutationVariables,
  TContext
> => {
  const mutationKey = getPostApiArbitrageAcceptMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiArbitrageAccept>>,
    PostApiArbitrageAcceptMutationVariables
  > = (props) => {
    const { arbitrageId, data } = props ?? {};

    return postApiArbitrageAccept(arbitrageId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiArbitrageAcceptMutationResult = NonNullable<Awaited<ReturnType<typeof postApiArbitrageAccept>>>;
export type PostApiArbitrageAcceptMutationBody = PostApiArbitrageAcceptBody;
export type PostApiArbitrageAcceptMutationError =
  | PostApiArbitrageAccept401
  | PostApiArbitrageAccept403
  | PostApiArbitrageAccept409
  | PostApiArbitrageAccept410
  | PostApiArbitrageAccept422
  | PostApiArbitrageAccept502
  | PostApiArbitrageAccept504;
export type PostApiArbitrageAcceptMutationVariables = { arbitrageId: string; data: PostApiArbitrageAcceptBody };

/**
 * @summary Acceptation d'un arbitrage
 */
export const usePostApiArbitrageAccept = <
  TError =
    | PostApiArbitrageAccept401
    | PostApiArbitrageAccept403
    | PostApiArbitrageAccept409
    | PostApiArbitrageAccept410
    | PostApiArbitrageAccept422
    | PostApiArbitrageAccept502
    | PostApiArbitrageAccept504,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiArbitrageAccept>>,
      TError,
      PostApiArbitrageAcceptMutationVariables,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiArbitrageAccept>>,
  TError,
  PostApiArbitrageAcceptMutationVariables,
  TContext
> => {
  return useMutation(getPostApiArbitrageAcceptMutationOptions(options), queryClient);
};
/**
 * Renvoie le pdf (base64) d'un avenant de support réinvesti, à consulter avant de répondre au questionnaire QPS. URL fournie dans `avenants[].url` des supports investis de GET /api/arbitrages/{arbitrageId}.
 * @summary Avenant d'un support d'arbitrage
 */
export const getApiArbitrageAvenant = (
  arbitrageId: string,
  params: GetApiArbitrageAvenantParams,
  signal?: AbortSignal
) => {
  return getApiArbitrageAvenantMutator<DocumentResponse>({
    url: `/api/arbitrages/${arbitrageId}/avenants`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetApiArbitrageAvenantQueryKey = (arbitrageId: string, params?: GetApiArbitrageAvenantParams) => {
  return [`/api/arbitrages/${arbitrageId}/avenants`, ...(params ? [params] : [])] as const;
};

export const getGetApiArbitrageAvenantQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiArbitrageAvenant>>,
  TError = void,
>(
  arbitrageId: string,
  params: GetApiArbitrageAvenantParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrageAvenant>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiArbitrageAvenantQueryKey(arbitrageId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiArbitrageAvenant>>> = ({ signal }) =>
    getApiArbitrageAvenant(arbitrageId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: arbitrageId !== null && arbitrageId !== undefined,
    staleTime: 1800000,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrageAvenant>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiArbitrageAvenantQueryResult = NonNullable<Awaited<ReturnType<typeof getApiArbitrageAvenant>>>;
export type GetApiArbitrageAvenantQueryError = void;

export function useGetApiArbitrageAvenant<TData = Awaited<ReturnType<typeof getApiArbitrageAvenant>>, TError = void>(
  arbitrageId: string,
  params: GetApiArbitrageAvenantParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrageAvenant>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiArbitrageAvenant>>,
          TError,
          Awaited<ReturnType<typeof getApiArbitrageAvenant>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiArbitrageAvenant<TData = Awaited<ReturnType<typeof getApiArbitrageAvenant>>, TError = void>(
  arbitrageId: string,
  params: GetApiArbitrageAvenantParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrageAvenant>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiArbitrageAvenant>>,
          TError,
          Awaited<ReturnType<typeof getApiArbitrageAvenant>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiArbitrageAvenant<TData = Awaited<ReturnType<typeof getApiArbitrageAvenant>>, TError = void>(
  arbitrageId: string,
  params: GetApiArbitrageAvenantParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrageAvenant>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Avenant d'un support d'arbitrage
 */

export function useGetApiArbitrageAvenant<TData = Awaited<ReturnType<typeof getApiArbitrageAvenant>>, TError = void>(
  arbitrageId: string,
  params: GetApiArbitrageAvenantParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrageAvenant>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiArbitrageAvenantQueryOptions(arbitrageId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Récupération du détail d'un arbitrage par son identifiant.
 *
 * Les propriétés `actualAllocation` et `newAllocation` répartissent l'encours du contrat par catégorie d'actifs, triées par libellé : `actualAllocation` **avant** application de l'arbitrage (encours réel du placement, supports enrichis SEL quand connus du SEL), `newAllocation` **après** (`actualAllocation` + montants investis − montants désinvestis). Elles valent `null` lorsque l'encours de base du placement n'a pas pu être récupéré.
 * @summary Récupération d'un arbitrage
 */
export const getApiArbitrageDetail = (arbitrageId: string, signal?: AbortSignal) => {
  return getApiArbitrageDetailMutator<ArbitrageDetailItem>({
    url: `/api/arbitrages/${arbitrageId}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiArbitrageDetailQueryKey = (arbitrageId: string) => {
  return [`/api/arbitrages/${arbitrageId}`] as const;
};

export const getGetApiArbitrageDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiArbitrageDetail>>,
  TError =
    | GetApiArbitrageDetail401
    | GetApiArbitrageDetail403
    | GetApiArbitrageDetail409
    | GetApiArbitrageDetail410
    | GetApiArbitrageDetail502,
>(
  arbitrageId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrageDetail>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiArbitrageDetailQueryKey(arbitrageId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiArbitrageDetail>>> = ({ signal }) =>
    getApiArbitrageDetail(arbitrageId, signal);

  return {
    queryKey,
    queryFn,
    enabled: arbitrageId !== null && arbitrageId !== undefined,
    staleTime: 1800000,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrageDetail>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiArbitrageDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getApiArbitrageDetail>>>;
export type GetApiArbitrageDetailQueryError =
  | GetApiArbitrageDetail401
  | GetApiArbitrageDetail403
  | GetApiArbitrageDetail409
  | GetApiArbitrageDetail410
  | GetApiArbitrageDetail502;

export function useGetApiArbitrageDetail<
  TData = Awaited<ReturnType<typeof getApiArbitrageDetail>>,
  TError =
    | GetApiArbitrageDetail401
    | GetApiArbitrageDetail403
    | GetApiArbitrageDetail409
    | GetApiArbitrageDetail410
    | GetApiArbitrageDetail502,
>(
  arbitrageId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrageDetail>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiArbitrageDetail>>,
          TError,
          Awaited<ReturnType<typeof getApiArbitrageDetail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiArbitrageDetail<
  TData = Awaited<ReturnType<typeof getApiArbitrageDetail>>,
  TError =
    | GetApiArbitrageDetail401
    | GetApiArbitrageDetail403
    | GetApiArbitrageDetail409
    | GetApiArbitrageDetail410
    | GetApiArbitrageDetail502,
>(
  arbitrageId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrageDetail>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiArbitrageDetail>>,
          TError,
          Awaited<ReturnType<typeof getApiArbitrageDetail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiArbitrageDetail<
  TData = Awaited<ReturnType<typeof getApiArbitrageDetail>>,
  TError =
    | GetApiArbitrageDetail401
    | GetApiArbitrageDetail403
    | GetApiArbitrageDetail409
    | GetApiArbitrageDetail410
    | GetApiArbitrageDetail502,
>(
  arbitrageId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrageDetail>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Récupération d'un arbitrage
 */

export function useGetApiArbitrageDetail<
  TData = Awaited<ReturnType<typeof getApiArbitrageDetail>>,
  TError =
    | GetApiArbitrageDetail401
    | GetApiArbitrageDetail403
    | GetApiArbitrageDetail409
    | GetApiArbitrageDetail410
    | GetApiArbitrageDetail502,
>(
  arbitrageId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrageDetail>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiArbitrageDetailQueryOptions(arbitrageId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Envoie à Salesforce le refus d'un arbitrage par le client
 * @summary Refus d'un arbitrage
 */
export const postApiArbitrageRefuse = (
  arbitrageId: string,
  postApiArbitrageRefuseBody: PostApiArbitrageRefuseBody,
  signal?: AbortSignal
) => {
  return postApiArbitrageRefuseMutator<void>({
    url: `/api/arbitrages/${arbitrageId}/refuse`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postApiArbitrageRefuseBody,
    signal,
  });
};

export const getPostApiArbitrageRefuseMutationKey = () => ['postApiArbitrageRefuse'] as const;

export const getPostApiArbitrageRefuseMutationOptions = <
  TError =
    PostApiArbitrageRefuse401 | PostApiArbitrageRefuse403 | PostApiArbitrageRefuse422 | PostApiArbitrageRefuse502,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiArbitrageRefuse>>,
    TError,
    PostApiArbitrageRefuseMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiArbitrageRefuse>>,
  TError,
  PostApiArbitrageRefuseMutationVariables,
  TContext
> => {
  const mutationKey = getPostApiArbitrageRefuseMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiArbitrageRefuse>>,
    PostApiArbitrageRefuseMutationVariables
  > = (props) => {
    const { arbitrageId, data } = props ?? {};

    return postApiArbitrageRefuse(arbitrageId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiArbitrageRefuseMutationResult = NonNullable<Awaited<ReturnType<typeof postApiArbitrageRefuse>>>;
export type PostApiArbitrageRefuseMutationBody = PostApiArbitrageRefuseBody;
export type PostApiArbitrageRefuseMutationError =
  PostApiArbitrageRefuse401 | PostApiArbitrageRefuse403 | PostApiArbitrageRefuse422 | PostApiArbitrageRefuse502;
export type PostApiArbitrageRefuseMutationVariables = { arbitrageId: string; data: PostApiArbitrageRefuseBody };

/**
 * @summary Refus d'un arbitrage
 */
export const usePostApiArbitrageRefuse = <
  TError =
    PostApiArbitrageRefuse401 | PostApiArbitrageRefuse403 | PostApiArbitrageRefuse422 | PostApiArbitrageRefuse502,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiArbitrageRefuse>>,
      TError,
      PostApiArbitrageRefuseMutationVariables,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiArbitrageRefuse>>,
  TError,
  PostApiArbitrageRefuseMutationVariables,
  TContext
> => {
  return useMutation(getPostApiArbitrageRefuseMutationOptions(options), queryClient);
};
/**
 * Récupération de la liste de tous les arbitrages de l'utilisateur connecté
 * @summary Récupération de tous les arbitrages
 */
export const getApiArbitrages = (params?: GetApiArbitragesParams, signal?: AbortSignal) => {
  return getApiArbitragesMutator<GetApiArbitrages200Item[]>({ url: `/api/arbitrages`, method: 'GET', params, signal });
};

export const getGetApiArbitragesQueryKey = (params?: GetApiArbitragesParams) => {
  return [`/api/arbitrages`, ...(params ? [params] : [])] as const;
};

export const getGetApiArbitragesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiArbitrages>>,
  TError = GetApiArbitrages401 | GetApiArbitrages403 | GetApiArbitrages502,
>(
  params?: GetApiArbitragesParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrages>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiArbitragesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiArbitrages>>> = ({ signal }) =>
    getApiArbitrages(params, signal);

  return { queryKey, queryFn, staleTime: 1800000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiArbitrages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiArbitragesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiArbitrages>>>;
export type GetApiArbitragesQueryError = GetApiArbitrages401 | GetApiArbitrages403 | GetApiArbitrages502;

export function useGetApiArbitrages<
  TData = Awaited<ReturnType<typeof getApiArbitrages>>,
  TError = GetApiArbitrages401 | GetApiArbitrages403 | GetApiArbitrages502,
>(
  params: undefined | GetApiArbitragesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrages>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiArbitrages>>,
          TError,
          Awaited<ReturnType<typeof getApiArbitrages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiArbitrages<
  TData = Awaited<ReturnType<typeof getApiArbitrages>>,
  TError = GetApiArbitrages401 | GetApiArbitrages403 | GetApiArbitrages502,
>(
  params?: GetApiArbitragesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrages>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiArbitrages>>,
          TError,
          Awaited<ReturnType<typeof getApiArbitrages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiArbitrages<
  TData = Awaited<ReturnType<typeof getApiArbitrages>>,
  TError = GetApiArbitrages401 | GetApiArbitrages403 | GetApiArbitrages502,
>(
  params?: GetApiArbitragesParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrages>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Récupération de tous les arbitrages
 */

export function useGetApiArbitrages<
  TData = Awaited<ReturnType<typeof getApiArbitrages>>,
  TError = GetApiArbitrages401 | GetApiArbitrages403 | GetApiArbitrages502,
>(
  params?: GetApiArbitragesParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiArbitrages>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiArbitragesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
